import About from './About';
import Education from './Education';
import Experience from './Experience';
import Projects from './Projects';
import Certification from './Certification';
import Achievements from './Achievements';

const Content = () => {
  return (
    <div id="content">
      <About />
      <br/>
      <br/>
      <Education />
      <br/>
      <br/>
      <Experience />
      <br/>
      <br/>
      <Projects />
      <br/>
      <br/>
      <Certification/>
      <br/>
      <br/>
      <Achievements/>
    </div>
  );
};

export default Content;
